var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclesFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CirclesFour"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 10.5C9.65685 10.5 11 9.15685 11 7.5C11 5.84315 9.65685 4.5 8 4.5C6.34315 4.5 5 5.84315 5 7.5C5 9.15685 6.34315 10.5 8 10.5Z",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 10.5C18.6569 10.5 20 9.15685 20 7.5C20 5.84315 18.6569 4.5 17 4.5C15.3431 4.5 14 5.84315 14 7.5C14 9.15685 15.3431 10.5 17 10.5Z",
    fill: "#FFB600",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 19.5C9.65685 19.5 11 18.1569 11 16.5C11 14.8431 9.65685 13.5 8 13.5C6.34315 13.5 5 14.8431 5 16.5C5 18.1569 6.34315 19.5 8 19.5Z",
    fill: "#FFB600",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17 19.5C18.6569 19.5 20 18.1569 20 16.5C20 14.8431 18.6569 13.5 17 13.5C15.3431 13.5 14 14.8431 14 16.5C14 18.1569 15.3431 19.5 17 19.5Z",
    fill: "#FFB600",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesFour);
export default __webpack_public_path__ + "static/media/CirclesFour.9f5d941507c5a5299020f660ff673e64.svg";
export { ForwardRef as ReactComponent };